import { Select } from "antd";
import { SelectProps } from "antd/lib";
import React from "react";

export const ViewComponentTypeSelect = (props: SelectProps) => {
  return (
    <Select
      {...props}
      options={[
        {
          label: "General",
          options: [
            { label: "Video", value: "VIEW_COMPONENT_TYPE_VIDEO" },
            { label: "MRAID", value: "VIEW_COMPONENT_TYPE_MRAID" },
            { label: "Image", value: "VIEW_COMPONENT_TYPE_IMAGE" },
            { label: "Countdown", value: "VIEW_COMPONENT_TYPE_COUNTDOWN" },
          ],
        },
        {
          label: "iOS Specific",
          options: [
            { label: "Countdown (Text)", value: "VIEW_COMPONENT_TYPE_COUNTDOWN_TEXT" },
            { label: "Mute", value: "VIEW_COMPONENT_TYPE_MUTE" },
            { label: "Unmute", value: "VIEW_COMPONENT_TYPE_UNMUTE" },
            { label: "Skip", value: "VIEW_COMPONENT_TYPE_SKIP" },
            { label: "Call To Action", value: "VIEW_COMPONENT_TYPE_CTA" },
          ],
        },
      ]}
    />
  );
};
